// Dependencies import
import React, { useState, useEffect, useCallback } from "react";
import {
  DataGrid,
  // GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
   GridToolbarDensitySelector,
  GridToolbarExport ,
} from "@mui/x-data-grid";
import { API } from "aws-amplify";
import Modal from "@mui/material/Modal";
//import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData } from "../../../redux/auth/authSlice";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";

// Local imports
import { Constants } from "../../../config/Constants";
import SelectPopup from "./SelectPopup";
import config from "../../../config/aws-exports";
import Breadcrumb from "../../Breadcrumbs/Breadcrumbs";

// Style imports
import Tusers from "./TotalUsers.module.scss";
//import { flex } from "@mui/system";
//import { Box } from "@mui/material";

// Custom Toolbard to export and filter for datagrid
function CustomToolbar() {
 
return (
  <GridToolbarContainer
    style={{ display: "flex", justifyContent: "flex-end" }}
  >
      <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
    <GridToolbarExport
      csvOptions={{
        fileName: `AllUsers-${new Date()
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-")}`,
        utf8WithBom: true,
      }}
    />
  </GridToolbarContainer>
);
}



// const useStyles = makeStyles((theme) => ({
//   root: {
//     "& .super-app-theme--header": {
//       backgroundColor: Constants.blue_color,
//       fontSize: "16px",
//       color: "rgb(255,255,255)",
//       fontFamily: "nunito",
//     },
//   },
//   modal: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "none",
//     transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
//   },
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: "#fff",
//   },
//   ".MuiDataGrid-root": {
//     fontSize: "14px",
//     fontFamily: "nunito",
//     fontWeight: 400,
//     color: "black",
//   },
// }));

// start of User component
const TotalUsers = () => {
  //const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [tenants, setTenants] = useState({});
  const [totalPass, setTotalPass] = useState(false);
  const [rows, setRows] = useState([]);
  const [spin, setSpin] = useState(false);
  const userDetails = useSelector(authData);
  const dispatch = useDispatch();

  console.log(" Rendering Only Once");

  // mapAllUsers: stable, only depends on setRows (stable)
  const mapAllUsers = useCallback(
    (value) => {
      let trows = [];
      for (let i = 0; i < value.length; i++) {
        let obj = {};
        obj.id = i;
        obj.firstname = value[i].first_name;
        obj.lastname = value[i].last_name || "";
        obj.lastname = obj.lastname === "null" ? "" : obj.lastname;
        obj.col2 = value[i].emailid;
        obj.col3 = value[i].oid;

        if (value[i].la !== null && value[i].la !== undefined) {
          const diff = moment(parseInt(value[i].la, 10)).fromNow();
          obj.col4 = diff;
        } else {
          obj.col4 = "";
        }

        obj.ur_id = value[i].ur_id;
        trows.push(obj);
      }
      setRows(trows);
    },
    [setRows]
  );

  // getAllTenantsUsers: depends on mapAllUsers
  const getAllTenantsUsers = useCallback(
    async (value) => {
      setSpin(true);
      const bodyParam = {
        body: {
          oid: value === "ALL ORGANIZATION" ? "ALL TENANT" : value,
          org: config.aws_org_id,
          schema: Constants.SCHEMA_NAME,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      try {
        const allten = await API.post(
          config.aws_cloud_logic_custom_name,
          Constants.GET_USERS,
          bodyParam
        );
        if (allten && allten.body) {
          mapAllUsers(allten.body);
        } else {
          setRows([]);
        }
      } catch (error) {
        console.error("getAllTenantsUsers error:", error);
      } finally {
        setSpin(false);
      }
    },
    [mapAllUsers]
  );

  // breadcrumb: compute desired breadcrumb and only dispatch if it differs from current to avoid loops
  const breadcrumb = useCallback(() => {
    const temp = [
      { name: "Dashboard", path: "/landingscreen" },
      { name: "Total Users", path: "/landingscreen/totalusers" },
    ];

    // If userDetails is missing, do nothing
    if (!userDetails) return;

    // If breadcrumb already equals desired, skip dispatch to avoid infinite loop
    try {
      const current = userDetails.breadcrumb || [];
      const same =
        Array.isArray(current) &&
        current.length === temp.length &&
        current.every(
          (c, idx) => c.name === temp[idx].name && c.path === temp[idx].path
        );

      if (same) return;

      const sdata = { ...userDetails, breadcrumb: temp };
      dispatch(awsSignIn(sdata));
    } catch (err) {
      console.error("breadcrumb error:", err);
    }
  }, [userDetails, dispatch]);

  // getTenants: fetch tenants and then users for selected tenant
  const getTenants = useCallback(
    async (value) => {
      setSpin(true);
      const bodyParam = {
        body: {
          oid: config.aws_org_id,
          schema: Constants.SCHEMA_NAME,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      try {
        const ten = await API.post(
          config.aws_cloud_logic_custom_name,
          Constants.GET_TENANTS,
          bodyParam
        );
        if (ten && ten.body) {
          setTenants(ten.body);
          // call users fetch for the provided tenant value
          getAllTenantsUsers(value);
        } else {
          setTenants({});
          setRows([]);
        }
      } catch (error) {
        console.error("getTenants error:", error);
      } finally {
        setSpin(false);
      }
    },
    [getAllTenantsUsers]
  );

  // Effects
  // 1) breadcrumb effect: run when userDetails changes (guard inside prevents dispatch loop)
  useEffect(() => {
    breadcrumb();
  }, [breadcrumb]);

  // 2) tenants/users effect: run when selectedTenant changes (or on mount)
  useEffect(() => {
    // If userDetails is undefined on first render, guard against calling
    const selected = userDetails ? userDetails.selectedTenant : undefined;
    getTenants(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTenants, userDetails ? userDetails.selectedTenant : null]);

  // function to open select tenant popup
  const handleOpen = () => {
    setOpen(true);
    setTotalPass(true);
  };

  // function to close select tenant popup
  const handleTotalClose = () => {
    setOpen(false);
    setTotalPass(false);
  };

  function onClick(param) {
    let sdata = { ...userDetails };
    sdata.user = param.row;
    let temp = [...(sdata.breadcrumb || [])];

    temp[2] = {
      name: param.row.firstname + " " + param.row.lastname,
      path: "/landingscreen/userInfo",
    };
    sdata.breadcrumb = temp;
    dispatch(awsSignIn(sdata));
  }

  const tcolumns = [
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
      headerClassName: `${Tusers.superHeader}`,
      renderCell: (params) => (
        <div>
          <Link
            to="/landingscreen/userInfo"
            style={{
              color: "black",
              textDecoration: "none",
              fontFamily: "14px",
              fontWeight: "400",
              
            }}
            onClick={() => {
              onClick(params);
            }}
          >
            {params.value}
          </Link>
        </div>
      ),
    },
    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
      headerClassName: `${Tusers.superHeader}`,
    },
    {
      field: "col2",
      headerName: "Email",
      flex: 1,
      headerClassName: `${Tusers.superHeader}`,
    },
    {
      field: "col3",
      headerName: "Organization",
      flex: 1,
      headerClassName: `${Tusers.superHeader}`,
    },
    {
      field: "col4",
      headerName: "Last Active",
      flex: 1,
      headerClassName: `${Tusers.superHeader}`,
    },
  ];

  // Start of main return
  return (
    <div className={Tusers.main}>
      <Breadcrumb Bindex={1} />
      <Backdrop className={Tusers.backdrop} open={spin}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={Tusers.modal}
        open={open}
        //closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={open}>
          <Box sx={{ p: 2 }}> */}
          <SelectPopup
            handleClose={handleTotalClose}
            tenants={tenants}
            getAllTenantsUsers={getAllTenantsUsers}
            totalPass={totalPass}
          />
          {/* </Box>
        </Fade> */}
      </Modal>

      {userDetails && userDetails.role === "Admin" ? (
        userDetails.role === "Manager" ? null : (
          <div className={Tusers.tenantselect}>
            <h4 className={Tusers.selecttenant}>Select Organization:</h4>
            <h5
              className={Tusers.tenantname}
              onClick={() => {
                handleOpen();
              }}
            >
              {userDetails.selectedTenant}
            </h5>
          </div>
        )
      ) : null}
      <div
        style={{
          height: 600,
          width: "100%",
          overflowY: "auto",
          paddingTop: "20px",
        }}
        className={Tusers.root}
      >
        <Paper>
          <div
            style={{ height: 500, width: "100%", overflowY: "auto"}}
            className={Tusers.root}
          >
            <DataGrid
              rows={rows}
              columns={tcolumns}
              className={Tusers.MuiDataGridRoot}
             
              slots={{
                toolbar:CustomToolbar,
              }}
              disableSelectionOnClick
            />
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default TotalUsers;
